import { createApp } from 'vue';
import App from './App.vue';


function mountVueApp() {
  const mountEl = document.getElementById('vue-app');
  if (mountEl && !mountEl.dataset.vueMounted) {
    mountEl.dataset.vueMounted = 'true';

    const app = createApp(App)
    // Activer Devtools
    //app.config.devtools = true
    app.mount(mountEl);

    //createApp(App).mount(mountEl);
    console.log('✅ Vue monté');
  }
}

if (document.readyState !== 'loading') {
  mountVueApp();
} else {
  document.addEventListener('DOMContentLoaded', mountVueApp);
}
